"use client";
import { useProps } from "../../core/MantineProvider/use-props/use-props.mjs";
import { factory } from "../../core/factory/factory.mjs";
import { ModalBaseOverlay } from "../ModalBase/ModalBaseOverlay.mjs";
import { useDrawerContext } from "./Drawer.context.mjs";
import Drawer_module_default from "./Drawer.module.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Drawer/DrawerOverlay.tsx
const DrawerOverlay = factory((_props) => {
	const { classNames, className, style, styles, vars, ...others } = useProps("DrawerOverlay", null, _props);
	return /* @__PURE__ */ jsx(ModalBaseOverlay, {
		...useDrawerContext().getStyles("overlay", {
			classNames,
			style,
			styles,
			className
		}),
		...others
	});
});
DrawerOverlay.classes = Drawer_module_default;
DrawerOverlay.displayName = "@mantine/core/DrawerOverlay";
//#endregion
export { DrawerOverlay };

//# sourceMappingURL=DrawerOverlay.mjs.map